var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._g({attrs:{"name":_vm.field.name,"validation-name":_vm.field.label,"id":_vm.id,"type":"text","error-behavior":"blur"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true},{key:"help",fn:function(){return [_vm._t("help")]},proxy:true}],null,true)},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }